import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';

/**
 * Current SMS reminder consent state for a single ContactPoint (telecom entry).
 *
 * This is the denormalized read cache used at send time and by the consent chip.
 * The append-only audit history lives server-side in the patient_consent_events table;
 * this extension is derived from the most-recent event per (patient, telecom, clinic).
 *
 * status: not-asked | opted-in | declined | opted-out-carrier
 * method: verbal | digital-form | sms-keyword | staff-revoked
 */
export default class ContactPointSmsReminderConsent extends BackboneElement {
    static __className = 'ContactPointSmsReminderConsent';

    __objectStructure = {
        status: String,
        method: String,
        lastUpdatedAt: String,
        suppressReminders: Boolean,
        suppressCareMessages: Boolean,
    };

    constructor(constructJson, className = 'ContactPointSmsReminderConsent') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
